import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="page">
      <h1>Página no encontrada</h1>
      <p>
        <Link to="/">Volver a órdenes</Link>
      </p>
    </div>
  );
}
